import { render } from "./vehicle_supplies.vue?vue&type=template&id=1d694e80&scoped=true"
import script from "./vehicle_supplies.vue?vue&type=script&lang=js"
export * from "./vehicle_supplies.vue?vue&type=script&lang=js"

import "./vehicle_supplies.vue?vue&type=style&index=0&id=1d694e80&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d694e80"]])

export default __exports__